<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="submitForgot">
                <card type="login">
                  <h4 style="font-size:18px;" slot="header" class="header text-center">Forgot Your Password</h4>

                  <fg-input v-model="form.email" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Your Email"></fg-input>


                  <br>

    

                  <p-button native-type="submit" slot="footer" type="warning" round block class="mb-3">Reset Password</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-3.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'
  import {UserService} from 'src/services/user.service'
  import swal from 'sweetalert2'
  import ApiService from '@/services/api.service';


  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      submitForgot(){
      		swal.showLoading();
      		
      		let uri = this.$base_url+'/api/v1/user_forgot_password';
      		ApiService.post(uri, this.form).then(response => {
      			if(response.data.message == "not_exist"){
         				swal({
							title: `Oops`,
							text: "There is no existing account with this email address. Please check and try again.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
         		}
         		else if(response.data.message == "passwords.sent"){
         			if(response.data.data =="passwords.throttled"){
         				swal({
							title: `Oops`,
							text: "You have tried to reset your password too many times. Please wait 3 minutes and try again.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
         			}
         			else{
         			 swal({
							title: `Success`,
							text: 'We have sent you an email with a link to reset your password.',
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-success',
							icon: 'success'
						  });
         			}
         		}//end if-else
         		
     		 })
      
      
      
      
      },
      login(e) {
      	
      }
    },
    data() {
      return {
      	form:{
          email: '',
          password: ''
        }
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
